/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@mic3/platform-ui';
import { connect } from 'react-redux';

import { loadTypeaheadProcessDefinitions } from 'store/actions/abox/myAppsActions';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { get } from 'app/utils/lo/lo';

/**
 * Select one or more groups using lazy loading.
 */
class ProcessTypeTypeahead extends PureComponent {
    static propTypes = {
        loadTypeaheadProcessDefinitions: PropTypes.func.isRequired,
        processDefinitions: PropTypes.arrayOf(PropTypes.object),
        isLoading: PropTypes.bool,
        filterBy: PropTypes.arrayOf(PropTypes.object),
    };

    constructor(props) {
        super(props);
        const { processDefinitions } = props;
        !(processDefinitions || []).length && props.loadTypeaheadProcessDefinitions(); // As its a static dropdown so if definitions are already loaded then there is no need to load them again
    }

    @bind
    @memoize()
    normalizeOptions(processDefinitions) {
        return processDefinitions.map(({ name, id }) => ({ label: name, value: id }));
    }

    render() {
        // remove the properties that we do not have to pass to the AbstractEntityAutocomplete
        const { filterBy, loadTypeaheadProcessDefinitions, processDefinitions, isLoading, ...abstractProcessTypeTypeaheadProps } = this.props;

        return (
            <Autocomplete
                placeholder="Search for a process type..."
                {...abstractProcessTypeTypeaheadProps}
                options={this.normalizeOptions(processDefinitions)}
                valueField="value"
            />
        );
    }
}

export default connect(
    state => ({
        isLoading: state.abox.app.typeaheadProcessDefinitions.isLoading,
        processDefinitions: get(state.abox.app.typeaheadProcessDefinitions.data, 'records', []),
    }),
    { loadTypeaheadProcessDefinitions }
)(ProcessTypeTypeahead);
